import { SUPPORTED_LOCALES } from '@/shared/localization';
import { maskPii } from './exception';

/**
 * 에러 로그에 첨부할 최소 앱 컨텍스트.
 * breadcrumb 시스템이 아님 — 마지막 사용자 액션 1건만 모듈 변수로 보관한다.
 */

export interface AppContextFields {
  app: {
    /** locale prefix 를 제거한 pathname (라우트 단위 집계용) */
    route?: string;
    /** 직전 사용자 액션 1건 (예: `click:data-testid=add-to-cart`) */
    last_action?: string;
  };
}

const LOCALE_PREFIX_PATTERN = new RegExp(
  `^/(?:${SUPPORTED_LOCALES.join('|')})(?=/|$)`,
);

const MAX_ACTION_LENGTH = 30;

let lastAction: string | undefined;

export function recordLastAction(action: string): void {
  lastAction = maskPii(action).slice(0, 'click:'.length + MAX_ACTION_LENGTH);
}

export function appContextFields(): AppContextFields {
  return {
    app: {
      route:
        typeof location !== 'undefined'
          ? location.pathname.replace(LOCALE_PREFIX_PATTERN, '') || '/'
          : undefined,
      last_action: lastAction,
    },
  };
}
